import { html } from 'lit';
import { LifeBuoy } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-life-buoy')
export class PdsIconLifeBuoy extends PdsIcon {
  @state()
  icon = LifeBuoy;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
